var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmArmenia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_7341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V15H60V0Z",
    fill: "#D90012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 15H0V30H60V15Z",
    fill: "#0033A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 30H0V45H60V30Z",
    fill: "#F2A800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_7341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmArmenia);
export default __webpack_public_path__ + "static/media/am Armenia.f15867c855116960c99f335649e4d964.svg";
export { ForwardRef as ReactComponent };